export default {
    services: state => state.services
  }
  